import { RunContextApp } from "framework/RCApp";
import { CMSApiResponse } from "framework/http/CMSApiClient";

export interface AnswerRequest {
  question: string;
  contextId: string;
}

export interface AnswerResponse {
  answer: string;
  confidence: number;
  sources?: string[];
  timestamp: string;
}

export const AssistantApis = {
  getAnswer: async (rc: RunContextApp, requestData: AnswerRequest): Promise<CMSApiResponse<AnswerResponse>> => {
    
    // Get user_id from session
    const userInfo = rc.session.getUserInfo();
    const userId = userInfo?.id;
    
    if (!userId) {
      return {
        error: {
          message: "User not authenticated",
          code: "UNAUTHORIZED"
        }
      };
    }
    
    // Combine question with user_id from session and context ID
    const fullRequestData = {
      question: requestData.question,
      user_id: userId.toString(),
      context_id: requestData.contextId
    };
    
    const answerResp = await rc.bffClient.getAnswer(fullRequestData);
    
    // Check if the response has an error property (error object)
    if ('error' in answerResp && answerResp.error) {
      return {
        error: answerResp.error
      };
    }

    // Handle successful AxiosResponse
    const apiData = (answerResp as any).data;

    // Transform the API response to match the expected format
    return {
      data: apiData,
      error: null
    };
  }
} 